const SIZE_UNITS = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
// Utility function to format bytes
export function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1000;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + SIZE_UNITS[i];
}
